const enum MatchTypes {
  ALL = 'ALL',
  ANY = 'ANY',
}

export default MatchTypes;
